import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as TickCircleIcon } from '../../assets/icons/tick-circle-icon.svg';

interface TimeRangeDropdownProperties {
  selected: string;
  onSelect: (value: string) => void;
}

/**
 * Custom dropdown component for selecting time ranges
 * @param {TimeRangeDropdownProperties} properties - The properties for the dropdown
 * @returns {JSX.Element} The rendered dropdown component
 */
function TimeRangeDropdown({ selected, onSelect }: TimeRangeDropdownProperties) {
  const { t } = useTranslation('reports');
  const options = [t('today'), t('yesterday'), t('week'), t('month'), t('year')];
  return (
    <div className="time-range-dropdown">
      {options.map((option) => (
        <div
          key={option}
          className={`dropdown-option ${selected === option ? 'selected' : ''}`}
          onClick={() => onSelect(option)}
          role="button"
          tabIndex={0}
          onKeyDown={(even) => {
            if (even.key === 'Enter' || even.key === ' ') {
              even.preventDefault();
              onSelect(option);
            }
          }}>
          <span>{option}</span>
          {selected === option && <TickCircleIcon />}
        </div>
      ))}
    </div>
  );
}

export default TimeRangeDropdown;
